import React from 'react';

const CatalogCompareIcon = function() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
      <path stroke="#000000" strokeLinecap="round" strokeWidth="1.5" d="M19 22H5M12 2v20M5 6h7"></path>
      <path
        stroke="#000000"
        strokeLinecap="square"
        strokeWidth="1.5"
        d="M16.167 13h5.644a.19.19 0 0 1 .189.19v.31a3.5 3.5 0 0 1-3.5 3.5v0a3.5 3.5 0 0 1-3.5-3.5v-.31a.19.19 0 0 1 .19-.19h.588M3.167 13H8.81a.19.19 0 0 1 .189.19v.31A3.5 3.5 0 0 1 5.5 17v0A3.5 3.5 0 0 1 2 13.5v-.31a.19.19 0 0 1 .19-.19h.588"
      ></path>
      <path
        stroke="#000000"
        strokeLinecap="round"
        strokeWidth="1.5"
        d="m18.5 6 3.5 7M5.5 6 2 13M18.5 6 15 13M5.5 6 9 13M19 6h-7"
      ></path>
    </svg>
  );
};

export default CatalogCompareIcon;